import type { FaireProductEntity } from "../../entity_types/product";

export const p_wqhube2j7p: FaireProductEntity = {
  token: "p_wqhube2j7p",
  type: "product",
  name: "GGO-2808 Duck Halls L/S  -  Military Green",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/3798ea75e3075af521f97236e1efbcbd1e0f75e0ede5436e177c45733907927c.png",
  galleryImageUrls: [],
  priceDollars: 13,
  description: "Get ready to Duck the Halls this holiday season! This festive long sleeve t-shirt features a fun duck design with the playful saying \"Duck the Halls,\" making it the perfect mix of holiday cheer and southern charm! Made from 100% cotton in a classic military green color, this tee is soft, comfy, and perfect for all your holiday festivities. Whether you're Christmas shopping, enjoying a cozy night in, or celebrating the season with friends and family, this cute and festive tee is sure to be a holiday favorite! ",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:56.461Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
